import React from 'react';

interface ConfirmModalProps {
  open: boolean;
  title?: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
  /** Da alzare quando la conferma va mostrata sopra un'altra modale. */
  zIndexClass?: string;
}

const ConfirmModal = ({
  open,
  title,
  message,
  confirmLabel = 'Elimina',
  cancelLabel = 'Annulla',
  onConfirm,
  onCancel,
  zIndexClass = 'z-[60]',
}: ConfirmModalProps) => {
  if (!open) return null;

  return (
    <div className={`${zIndexClass} fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-75 p-4`}>
      <div className="bg-white rounded-xl p-8 shadow-2xl max-w-md mx-4 w-full flex flex-col items-center gap-4">
        {title && <h2 className="text-fpcred font-bold text-xl text-center">{title}</h2>}
        <p className="text-center text-gray-700">{message}</p>
        <div className="flex justify-center gap-4 w-full mt-2">
          <button
            type="button"
            className="bg-fpcpink text-fpcred font-bold rounded-lg w-full p-2"
            onClick={onCancel}>
            {cancelLabel}
          </button>
          <button
            type="button"
            className="bg-fpcred text-white font-bold rounded-lg w-full p-2 hover:bg-buttonhover transition-colors"
            onClick={onConfirm}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
